import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import withReduxProvider from "web/react/redux-provider";
import PropTypes from "prop-types";
import Button from "web/react/components/button/button";
import ProductDescriptionExpressCheckoutDisclaimer from "web/react/components/product-description/product-description-express-checkout/product-description-express-checkout-disclaimer/product-description-express-checkout-disclaimer";
import ProductDescriptionExpressCheckoutSizeSelect from "web/react/components/product-description/product-description-express-checkout/product-description-express-checkout-size-select/product-description-express-checkout-size-select";
import analytics from "web/script/analytics/analytics";
import logging from "web/script/utils/logging";
import requester from "web/script/modules/requester";
import facebookEvents from "web/script/analytics/facebook-events";
import { incrementBasketCount as _incrementBasketCount } from "web/redux/ducks/app-header-cart";
import { openShippingAndReturnsOverlay as _openShippingAndReturnsOverlay } from "web/redux/ducks/shipping-and-returns-overlay";
import { connect } from "react-redux";
import { gettext } from "web/script/modules/django-i18n";
import { useGetSaveForLaterStatus } from "web/react/hooks/use-save-for-later/use-save-for-later";
import _map from "lodash/map";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { useLeadHref } from "web/react/components/lead-link/lead-link";
import styles from "./product-description-express-checkout.css";

function mapDispatchToProps(dispatch) {
  return {
    incrementBasketCount: function incrementBasketCount() {
      return dispatch(_incrementBasketCount());
    },
    openShippingAndReturnsOverlay: function openShippingAndReturnsOverlay(linkId) {
      return dispatch(_openShippingAndReturnsOverlay(linkId));
    }
  };
}

export function ProductDescriptionExpressCheckout(_ref) {
  var className = _ref.className,
      incrementBasketCount = _ref.incrementBasketCount,
      productId = _ref.productId,
      sizes = _ref.sizes,
      leadLabel = _ref.leadLabel,
      bingTraffic = _ref.bingTraffic,
      storeLeadUrl = _ref.storeLeadUrl;
  var selectedIndex = 0;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      buyButtonEnabled = _useState2[0],
      setBuyButtonEnabled = _useState2[1];

  var _useGetSaveForLaterSt = useGetSaveForLaterStatus(productId),
      _useGetSaveForLaterSt2 = _slicedToArray(_useGetSaveForLaterSt, 1),
      isSavedForLater = _useGetSaveForLaterSt2[0];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      expanded = _useState6[0],
      setExpanded = _useState6[1];

  var leadUrl = useLeadHref(storeLeadUrl, "click-to-see-more-sizes");

  function handleSeeMore(event) {
    event.preventDefault();
    setExpanded(true);
  }

  function _sendBuyActionAnalytics() {
    var label = isSavedForLater ? "save_for_later_add_to_cart" : "add_to_cart_button";

    try {
      var analyticsPromises = [analytics.event("CART", "ADD_ITEM", label), analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents.ADD_TO_CART, {
        content_ids: productId,
        content_type: "product"
      }, true)];
      return Promise.all(analyticsPromises);
    } catch (e) {
      logging.error(e);
    }
  }

  function addToBag() {
    return _addToBag.apply(this, arguments);
  }

  function _addToBag() {
    _addToBag = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var optionValue, requestObj, body, jsonData, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setBuyButtonEnabled(false);
              optionValue = sizes[selectedIndex].option_value;
              requestObj = {
                icon: true,
                raw_size: optionValue.raw_size,
                link_id: optionValue.link_id
              };
              body = {
                buy_option: JSON.stringify(requestObj),
                is_base64_encoded: false
              };

              _sendBuyActionAnalytics();

              jsonData = undefined;
              _context.prev = 6;
              _context.next = 9;
              return requester.post("/cart/add/", body);

            case 9:
              jsonData = _context.sent;
              _context.next = 18;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](6);
              logging.error(_context.t0);
              analytics.event("CART", "ADD_TO_BAG_ERROR");
              setErrorMessage("Something went wrong!");
              return _context.abrupt("return");

            case 18:
              if (jsonData && jsonData.success) {
                incrementBasketCount();
              } else {
                message = _map(jsonData.data, "message").join(" ");
                setErrorMessage(message);

                if (message.toLowerCase().indexOf("something went wrong trying to add this product to your cart") > -1) {
                  analytics.event("cart", "add_to_cart_error", "cart_add_item_error");
                } else if (message.toLowerCase().indexOf("this product seems to no longer be in stock") > -1) {
                  analytics.event("cart", "add_to_cart_error", "product_no_longer_in_stock");
                } else if (message.toLowerCase().indexOf("you need to select an option") > -1) {
                  analytics.event("cart", "add_to_cart_error", "no_buy_option_detected");
                } else if (message.toLowerCase().indexOf("you need to select a size") > -1) {
                  analytics.event("cart", "add_to_cart_error", "no_size_detected");
                } else if (message.toLowerCase().indexOf("you cannot have more than") > -1) {
                  analytics.event("cart", "add_to_cart_error", "too_many_items_in_cart");
                }
              }

              setBuyButtonEnabled(true);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 12]]);
    }));
    return _addToBag.apply(this, arguments);
  }

  var addToBagButtonStyle = bingTraffic === false ? "primary" : "temp-grey";

  if (bingTraffic && !expanded) {
    return React.createElement("a", {
      href: "#",
      onClick: handleSeeMore,
      className: styles.seeMore
    }, React.createElement(SVGIcon, {
      name: "chevron",
      rotate: 90
    }), gettext("product.buy_area.see_more_buying_options"));
  } else {
    return React.createElement("div", {
      className: className
    }, React.createElement("div", {
      className: styles.componentColumn
    }, React.createElement(ProductDescriptionExpressCheckoutDisclaimer, {
      retailerName: leadLabel,
      leadUrl: storeLeadUrl,
      productId: productId
    }), React.createElement(ProductDescriptionExpressCheckoutSizeSelect, {
      sizes: sizes,
      leadUrl: leadUrl,
      productId: productId
    }), React.createElement(Button, {
      onClick: addToBag,
      fullWidth: true,
      styleType: addToBagButtonStyle,
      disabled: !buyButtonEnabled,
      className: styles.addToBag
    }, React.createElement("div", null, React.createElement("span", null, gettext("product.buy_area.add_to_bag_btn_text"))))), errorMessage && React.createElement("div", {
      className: styles.addToBagError
    }, React.createElement("em", null, errorMessage)));
  }
}
ProductDescriptionExpressCheckout.propTypes = {
  sizeGuideLink: PropTypes.string,
  sizes: PropTypes.arrayOf(PropTypes.shape({
    option_value: PropTypes.shape({
      link_id: PropTypes.string,
      raw_size: PropTypes.string,
      icon: PropTypes.bool
    }),
    human_size: PropTypes.string,
    raw_size: PropTypes.string,
    min_price: PropTypes.string
  })),
  className: PropTypes.string,
  incrementBasketCount: PropTypes.func,
  productId: PropTypes.string,
  storeLeadUrl: PropTypes.string,
  leadLabel: PropTypes.string,
  openShippingAndReturnsOverlay: PropTypes.func,
  bingTraffic: PropTypes.bool
};
export default withReduxProvider(connect(null, mapDispatchToProps)(ProductDescriptionExpressCheckout));